import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { decrypt, encrypt } from '../utils/crypt';

@Injectable({
  providedIn: 'root',
})
export class LocalService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  public saveData(key: string, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      // 1. Convert to JSON string first (handles objects, arrays, and primitives)
      const stringValue = JSON.stringify(value);

      // 2. Encrypt and save
      const encryptedData = encrypt(stringValue);
      localStorage.setItem(key, encryptedData);
    }
  }

  public getData(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      const data = localStorage.getItem(key);

      // 1. Check if data exists in localStorage
      if (!data) return null;

      try {
        const decryptedData = decrypt(data);

        // 2. Check if decrypted result is valid (not empty)
        if (!decryptedData) return null;

        return JSON.parse(decryptedData);
      } catch (error) {
        console.error('Error parsing or decrypting data:', error);
        return null;
      }
    }
    return null;
  }

  public removeData(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      // Check if key exists before attempting removal (optional but safer)
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    }
  }

  public clearData() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
